export default __webpack_public_path__ + "static/media/logo-dark.0e8d0bff.png";